import React, { type FC } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Separator } from "@/components/ui/separator"

interface ModalProps {
  isOpen: boolean
  onClose?: () => void
  showCloseButton?: boolean
  title: string
  startTitleIcon?: React.ReactNode
  children: React.ReactNode
  width?: number | string
  closeOnBackgroundClick?: boolean
}

export const CustomModal: FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  startTitleIcon,
  children,
  width = "560px",
}) => {
  if (!isOpen) return null

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent style={{ maxWidth: width }} className="p-0">
        <DialogHeader className="px-5 pt-4 pb-0">
          <DialogTitle className="flex items-center gap-2">
            {startTitleIcon && <div className="h-8 w-8">{startTitleIcon}</div>}
            {title}
          </DialogTitle>
        </DialogHeader>
        <Separator />
        <div className="px-5 pb-5">{children}</div>
      </DialogContent>
    </Dialog>
  )
}
